import UserLoginMessage from "./UserLoginMessage.vue"
import ContributorAssignedToMyselfMessage from "./ContributorAssignedToMyselfMessage.vue"
import ActiveContributorAssignedToMyself from "./ActiveContributorAssignedToMyself.vue"
import NewContentMessage from "./NewContentMessage.vue"
import WorkflowStateChangeMessage from "./WorkflowStateChangeMessage.vue"
import WorkflowStateRequireAttentionMessage from './WorkflowStateRequireAttentionMessage.vue';
import WorkflowTypeChangeMessage from "./WorkflowTypeChangeMessage.vue"
import ContentApprovedMessage from "./ContentApprovedMessage.vue"
import DownloadScormSuccess from "./DownloadScormSuccess.vue"
import DownloadScormFail from "./DownloadScormFail.vue"
export default [
    UserLoginMessage,
    ContributorAssignedToMyselfMessage,
    ActiveContributorAssignedToMyself,
    NewContentMessage,
    WorkflowStateChangeMessage,
		WorkflowStateRequireAttentionMessage,
    WorkflowTypeChangeMessage,
    ContentApprovedMessage,
    DownloadScormSuccess,
    DownloadScormFail
]